module.exports = __webpack_public_path__ + "static/media/Montserrat-LightItalic.57db0d99.ttf";